import React from "react";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import PasswordGenerator from "Components/PasswordGenerator";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";
import t from "Utils/translation";

import cx from "classnames";
import s from "./passwordManagers.scss";

export default class PasswordForm extends React.Component {
  state = {
    viewFields: ["password", "password_confirmation"],
  };

  validate({ password, password_confirmation }) {
    let errors = {};
    if (password.length < 8) errors.password = "is too short";
    if (password !== password_confirmation) errors.password_confirmation = "is not the same";
    return errors;
  }

  componentWillUnmount() {
    this.props.resetFields("password_confirmation", "password");
  }

  submit = (e) => {
    const { formData, setFormLoading, submitForm, setFormErrors } = this.props;
    e.preventDefault();
    setFormLoading();

    const errors = this.validate(formData);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      submitForm(formData, this.state.viewFields);
    }
  };

  fillPasswordFields = (generatedPassword) => {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword,
    });
  };

  render() {
    const { className, isFormLoading, setFormFieldValue, formData, formErrors } = this.props;

    return (
      <form className={s.security} method="post" onSubmit={this.submit}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine("password", "password_confirmation") && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>

          <div className={s.infoBtnGroup}>
            <Button docsKey="managers_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.password.title")}</div>
              <div className="sectionDesc">{t("settings.sections.password.desc.manager")}</div>
            </div>
            <div className="formsSectionSP">
              <Input
                className="inputFull2"
                name="password"
                label={t("input.label.password.new")}
                type="password"
                onChange={setFormFieldValue}
                value={formData.password}
                errors={formErrors.password}
              />
              <Input
                className="inputFull2"
                name="password_confirmation"
                label={t("input.label.passwordConfirm.new")}
                type="password"
                onChange={setFormFieldValue}
                value={formData.password_confirmation}
                errors={formErrors.password_confirmation}
              />
              <PasswordGenerator className="inputFull2" onNewPassword={this.fillPasswordFields} />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
